import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Country, Theme } from '@/domain/core';

import type { ICountry, ITheme } from '@/domain/core';

interface AppState {
  country: ICountry;
  allowed_countries: ICountry[];
  theme: ITheme;
  setCountry: (country: ICountry) => void;
  setAllowedCountries: (countries: ICountry[]) => void;
  setTheme: (theme: ITheme) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      // Default values
      country: Country.MEX,
      allowed_countries: [Country.MEX],
      theme: Theme.LIGHT,

      // Actions
      setCountry: (country: ICountry) => set({ country }),
      setAllowedCountries: (allowed_countries: ICountry[]) => set({ allowed_countries }),
      setTheme: (theme: ITheme) => {
        set({ theme });
        // Sincroniza con DaisyUI (data-theme) y Tailwind (class)
        document.documentElement.setAttribute('data-theme', theme);
        if (theme === Theme.DARK) {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      },
    }),
    {
      name: 'app-settings',
      // Se ejecuta al cargar la app para aplicar el tema guardado sin parpadeos
      onRehydrateStorage: () => (state) => {
        if (state) {
          document.documentElement.setAttribute('data-theme', state.theme);
          if (state.theme === Theme.DARK) {
            document.documentElement.classList.add('dark');
          } else {
            document.documentElement.classList.remove('dark');
          }
        }
      },
    },
  ),
);
